import { render, staticRenderFns } from "./TaskListHeader.vue?vue&type=template&id=4e0f4198&"
import script from "./TaskListHeader.vue?vue&type=script&lang=js&"
export * from "./TaskListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports